import {
  get as getLocalStorageItem,
  remove as removeLocalStorageItem,
  set as setLocalStorageItem,
} from 'lib/storage/isomorphicLocalStorage'

export type ExpiringDismissalEntry = {
  endDate: string
}

export function isExpiringDismissalEntry(value: unknown): value is ExpiringDismissalEntry {
  return typeof value === 'object' &&
    value !== null &&
    'endDate' in value &&
    typeof value.endDate === 'string'
}

export function isExpiringDismissalExpired(endDate: string): boolean {
  return Date.now() > Date.parse(endDate)
}

export function getExpiringDismissal(key: string): ExpiringDismissalEntry | undefined {
  const value = getLocalStorageItem(key)
  return isExpiringDismissalEntry(value) ? value : undefined
}

/** True while a stored endDate is still in the future; deletes expired entries. */
export function isExpiringDismissalActive(key: string): boolean {
  try {
    const dismissal = getExpiringDismissal(key)
    if (!dismissal) {
      return false
    }

    if (isExpiringDismissalExpired(dismissal.endDate)) {
      removeLocalStorageItem(key)
      return false
    }

    return true
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted.
    return false
  }
}

export function setExpiringDismissal(key: string, endDate: string) {
  try {
    setLocalStorageItem(key, {
      endDate,
    } satisfies ExpiringDismissalEntry)
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted. Do not block page rendering.
  }
}
